import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import BasicUserInformation from "../BasicUserInformation/BasicUserInformation";
import AddressData from "../AddressData/AddressData";
import ReviserData from "../ReviserData/ReviserData";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import Row from "../WrapperComponents/Row";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import ColDynamic from "../WrapperComponents/ColDynamic";
import { Spinner } from "react-bootstrap";
import NameAndAddressData from "../NameAndAddressData/NameAndAddressData";

const EntryForm3 = (props) => {

  const popuniZagradu = (clan) =>{
      if(clan.ime && clan.prezime){
        return `(${clan.ime} ${clan.prezime})`;
      }else if(clan.nazDrustva){
        return `(${clan.nazDrustva})`;
      }
    return "(Novi unos)";
  }

  const value = props.parentState.newFormData.competentBodyData.nazTijela;
  const { reviserRegistration } = props.parentState.newFormData;
  const mappedReviserData = reviserRegistration.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`reviser-registration-collapse${index}`}
        clickText={`Podaci o revizorskom društvu ili samostalnom revizoru kod kojeg je ovlašteni revizor zaposlen ili s kojim je povezan kao partner ili na drugi način 
          ${popuniZagradu(element)}
        `}
      >
        <ReviserData id={element.id} {...props} />
        <Row>
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length - 1 === index ? 
              <ButtonComponent
                id={`reviser-registration-add${element.id}`}
                onClick={(e) =>
                  props.multiplyComponent(e, {
                    formGroup: "reviserRegistration",
                  })
                }
              >
                Dodaj novi
              </ButtonComponent>
            :
              null
            }
          </ColDynamic>
          
          <ColDynamic className="col-lg-4">
            {reviserRegistration.length > 1 && (
              <ButtonComponent
                variant="danger"
                id={`reviser-registration-remove${element.id}`}
                onClick={(e) =>
                  props.removeComponentHandler(e, {
                    formGroup: "reviserRegistration",
                  })
                }
              >
                Ukloni
              </ButtonComponent>
            )}
          </ColDynamic>
        </Row>
      </CollapsableWrapper>
    );
  });

  const { reviserData } = props.parentState.newFormData;
  const mappedCompBodyReg = reviserData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`comp-body-reg${element.id}-collapse`}
        clickText={`Registracija ovlaštenog revizora kod nadležnog tijela drugih država članica i kao revizora kod nadležnih tijela u trećim zemljama 
        ${reviserData.length > 1 ? ` (${index + 1})` : ""}
       `}
      >
        <MappedRegistrationComponent
          requiredAddress
          group="reviserData"
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { competentBodyData } = props.parentState.newFormData;
  const mappedCompBodyData = competentBodyData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`comp-body-data${element.id}-collapse`}
        clickText={`Naziv i adresa nadležnih tijela država članica odgovornih za odobrenje, registraciju, nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i revizorskih društava    ${
          competentBodyData.length > 1 ? ` (${index + 1})` : ""
        }`}
      >
        <NameAndAddressData
          group={"competentBodyData"}
          id={element.id}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText={"Osnovni podaci"}>
        <BasicUserInformation
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt == 1
          }
          required
          {...props}
        />
      </CollapsableWrapper>
      <CollapsableWrapper clickText={"Podaci o adresi i registraciji"}>
        <AddressData
          permitDateLabel="Datum odobrenja za rad"
          permitNumberLabel="Broj odobrenja za rad"
          required
          requiredRegistration
          requiredBrPoste
          requiredKbr
          disableDistrict={disableDistrict}
          disableCity={disableCity}
          disableCounty={disableCounty}
          isRegistryOfCertifiedAuditors={true}
          {...props}
        />
      </CollapsableWrapper>
      {mappedReviserData}
      {mappedCompBodyReg}
      {mappedCompBodyData}
      <br></br>
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </>
  );
};

export default EntryForm3;
